import { render, staticRenderFns } from "./RunnitBoardMemberRow.vue?vue&type=template&id=a729dd10&scoped=true"
import script from "./RunnitBoardMemberRow.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardMemberRow.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardMemberRow.vue?vue&type=style&index=0&id=a729dd10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a729dd10",
  null
  
)

export default component.exports